import { isNumber } from 'lodash';
import { PAGE_VIEW_MODES } from '../../../../constants/page-view-modes';

const PerformanceItemsMapper = {
  performanceMetricToTableData: (performanceItem, viewMode) => ({
    id: performanceItem.Id,
    measurementName: performanceItem.MeasurementName,
    measurementDescription: performanceItem.MeasurementDescription,
    measurementCalculation: performanceItem.MeasurementCalculation,
    measurementUnit: performanceItem.MeasurementUnit,
    numerator: performanceItem.Numerator,
    denominator: performanceItem.Denominator,
    targetDescription: performanceItem.TargetDescription,
    goodPerformanceIndicator: performanceItem.GoodPerformanceIndicator,
    timeBounds: performanceItem.TimeBounds,
    timeFrame: performanceItem.TimeFrame,
    captureFrequency: performanceItem.CaptureFrequency,
    reportFrequency: performanceItem.ReportFrequency,
    measurementLevel: performanceItem.MeasurementLevel,
    measurementUse: performanceItem.MeasurementUse,
    limitationsOrBlindSpots: performanceItem.LimitationsOrBlindSpots,
    qualityDomain: performanceItem.QualityDomain,
    customQualityDomainDefinition: performanceItem.CustomQualityDomainDefinition,
    businessObjective: performanceItem.BusinessObjective,
    qualityObjective: performanceItem.QualityObjective,
    dataPointId: performanceItem.DataPoint.Id,
    status: performanceItem.DataPoint.Status,
    lowerLimit: isNumber(performanceItem.DataPoint.LowerLimit)
      ? performanceItem.DataPoint.LowerLimit
      : undefined,
    upperLimit: isNumber(performanceItem.DataPoint.UpperLimit)
      ? performanceItem.DataPoint.UpperLimit
      : undefined,
    actual: performanceItem.DataPoint.Actual,
    notes: performanceItem.DataPoint.Notes,
    addedInCurrentCheckpoint: performanceItem.AddedInCurrentCheckpoint,
    isDeletable: performanceItem.IsDeletable,
    parentCheckpointPerformanceItemId: performanceItem.ParentCheckpointPerformanceItemId,
    referenceCheckpointDatapoint: getReferenceDatapointToTableData(performanceItem, viewMode)
  }),
  performanceMetricToApolloInput: metric => ({
    Id: metric.id,
    ParentCheckpointPerformanceItemId: metric.parentCheckpointPerformanceItemId,
    MeasurementName: metric.measurementName,
    MeasurementDescription: metric.measurementDescription,
    MeasurementCalculation: metric.measurementCalculation,
    MeasurementUnit: metric.measurementUnit,
    Numerator: metric.numerator,
    Denominator: metric.denominator,
    TargetDescription: metric.targetDescription,
    GoodPerformanceIndicator: metric.goodPerformanceIndicator,
    TimeBounds: metric.timeBounds,
    TimeFrame: metric.timeFrame,
    CaptureFrequency: metric.captureFrequency,
    ReportFrequency: metric.reportFrequency,
    MeasurementLevel: metric.measurementLevel,
    MeasurementUse: metric.measurementUse,
    LimitationsOrBlindSpots: metric.limitationsOrBlindSpots,
    QualityDomain: metric.qualityDomain,
    CustomQualityDomainDefinition: metric.customQualityDomainDefinition,
    BusinessObjective: metric.businessObjective,
    QualityObjective: metric.qualityObjective,
    DataPoint: {
      Id: metric.dataPointId,
      LowerLimit: metric.lowerLimit,
      UpperLimit: metric.upperLimit,
      Actual: metric.actual,
      Notes: metric.notes,
      Status: metric.status
    }
  })
};

const getReferenceDatapointToTableData = (metric, viewMode) => {
  const parentDataPonint = metric.ParentCheckpointPerformanceItem
    ? metric.ParentCheckpointPerformanceItem.DataPoint
    : null;

  const referenceDataPoint = viewMode === PAGE_VIEW_MODES.ADD ? parentDataPonint : metric.DataPoint;

  return {
    actual: referenceDataPoint ? referenceDataPoint.Actual : null,
    lowerLimit: referenceDataPoint ? referenceDataPoint.LowerLimit : null,
    notes: referenceDataPoint ? referenceDataPoint.Notes : null,
    upperLimit: referenceDataPoint ? referenceDataPoint.UpperLimit : null,
    status: referenceDataPoint ? referenceDataPoint.Status : null
  };
};

export default PerformanceItemsMapper;
